module.exports = __webpack_public_path__ + "img/fu0002.78e0e2a3.webp";